import React from 'react';
import Layout from './Layout';
import { Encabezado } from './Encabezado';

const SPOTIFY = 'https://open.spotify.com/show/56dQAu73j4a0QaLRO44oa7';
const APPLE = 'https://podcasts.apple.com/mx/podcast/internet-en-pandemia/id1552637394';

// Episodio que aparece en grande al inicio de la página
const EPISODIO_DESTACADO = 'T01E01';

// Temporada 1 de "Internet en Pandemia", del más reciente al primero. `youtube` es el id del video.
const EPISODIOS = [
    {
        clave: 'T01E10', youtube: '2xu2VQ8Noe4',
        titulo: 'Ciclista profesional Representando a Ixmiquilpan, Hidalgo y México CON Francisco Lara',
        descripcion: 'En el noveno episodio platicamos con Francisco Lara un orgullo Ixmiquilpense en el ciclismo que ha logrado obtener premios nacionales e internacionales. Nos cuenta experiencias que ha tenido practicando el ciclismo, sus retos y motivaciones.',
    },
    {
        clave: 'T01E09', youtube: 'ft_a0aE1ThY',
        titulo: 'La importancia de la difusión de las lenguas indígenas como el Hñähñu CON Erasmo Huizache',
        descripcion: 'En el noveno episodio platicamos con Erasmo Huizache del municipio de Cardonal quien ha sido un promotor de la lengua indígena. Ha su corta edad ha tenido la oportunidad de colaborar en la traducción de 4 libros al Hña-Hñu. Conoce con nosotros sobre la historia de las lenguas indígenas, la discriminación, el peligro que corren por desaparecer y la importancia que tienen los padres en la difusión de la lengua materna.',
    },
    {
        clave: 'T01E08', youtube: '7xTvsIAuKG8',
        titulo: 'Nutrióloga habla sobre como tener buena alimentación en tiempos de pandemia CON Saraí Pérez',
        descripcion: 'En el octavo episodio platicamos con Saraí Pérez nos platica sobre las consecuencias que la pandemia a traído en el campo de la nutrición. Conocemos la ventaja que tenemos de estar en el valle del mezquital pues tenemos una gastronomía y agricultura muy vasta. ¿Ya sabes como cuidar tu salud para no estar en un grupo vulnerable de covid-19?',
    },
    {
        clave: 'T01E07', youtube: 'QwuDLu4DIvQ',
        titulo: 'Músico Profesional en pandemia, retos, historia CON Joel Peña',
        descripcion: 'En el séptimo episodio platicamos con Joel Peña un Músico, Compositor y Catedrático Hidalguense nos habla sobre el impacto de la pandemia en la industria de la música y la ayuda del internet en el sector. También nos cuenta un poco su historia como músico y los principales retos que ha tenido.',
    },
    {
        clave: 'T01E06', youtube: 'ZCqqOPZLekM',
        titulo: 'Emprendedores poniendo en alto la cultura indígena CON Textiles Caramaya',
        descripcion: 'En el sexto episodio platicamos con los fundadores de Textiles Caramaya que están buscando preservar las raíces del valle del mezquital a través de indumentarias con diseños únicos que caracterizan a la cultura indígena. Conoce su proyecto en donde a través de un grupo de artesanos, diseñadores, artistas están haciendo un cambio en la moda.',
    },
    {
        clave: 'T01E05', youtube: 'zvF8PviAGQ8',
        titulo: 'Innovando el periodismo en Ixmiquilpan CON Roberto Bravo',
        descripcion: 'En el quinto episodio platicamos con el periodista Roberto Bravo, quien todos los días abre un espacio al diálogo para enterarnos y discutir las noticias de Ixmiquilpan. Nos cuenta sobre cómo le ha ayudado el Internet en su proyecto de RB Periodismo para conversar, qué podemos hacer para informarnos mejor y mucho más.',
    },
    {
        clave: 'T01E04', youtube: 'SVUA8MmT9nU',
        titulo: 'Joven Ixmiquilpense aspirando a lo grande CON Brenda Esteban',
        descripcion: 'En el cuarto episodio platicamos con Brenda Esteban, una joven ixmiquilpense que ha superado varios retos. Descubre como es que ella se va a Francia a representar nuestra gastronomía así como el impacto que ha tenido la pandemia en su vida en temas como su libro "Por séptima vez", su emprendimiento y su vida profesional.',
    },
    {
        clave: 'T01E03', youtube: 'xIwGjBUZ2UM',
        titulo: 'Un profesor cambiando a una generación CON Alfonso Hernández',
        descripcion: 'En el tercer episodio platicamos con Alfonso Hernández, ganador de la Beca Itmex 2020 en apoyo a la educación y un profesor que nos inspira. Hablaremos sobre su forma de ver la vida, sus retos personales, migración a Estados Unidos, docencia en zonas rurales y la manera tan creativa en la que sigue dando clases.',
    },
    {
        clave: 'T01E02', youtube: 'IYrOaLjFBc8',
        titulo: 'Una mujer japonesa en México CON Katsumi Nakatake',
        descripcion: 'En el segundo episodio platicamos con Katsumi Nakatake sobre las diferencias entre Japón y México, los cambios que ha traído la pandemia a su familia, los retos que ha afrontado y muchas cosas más.',
    },
    {
        clave: 'T01E01', youtube: '6qiuvOP7Qp4',
        titulo: 'El valor de la vocación de enseñar CON Cesar Araujo',
        descripcion: 'En el primer episodio platicamos sobre el municipio de Ixmiquilpan y alrededores, educación, tecnología y más con César Araujo, director del Instituto Guadalupe Victoria y maestro en Ixmiquilpan por más de 40 años.',
    },
];

const Plataformas = ({ episodio }) => (
    <div className="podcastItmex-plataformas">
        <a href={`https://youtu.be/${episodio.youtube}`} target="_blank" rel="noopener noreferrer" aria-label="Ver en YouTube"><i className="fab fa-youtube"></i></a>
        <a href={SPOTIFY} target="_blank" rel="noopener noreferrer" aria-label="Escuchar en Spotify"><i className="fab fa-spotify"></i></a>
        <a href={APPLE} target="_blank" rel="noopener noreferrer" aria-label="Escuchar en Apple Podcasts"><i className="fas fa-podcast"></i></a>
    </div>
);

const Episodio = ({ episodio, destacado }) => (
    <article className={'podcastItmex' + (destacado ? ' podcastItmex--destacado' : '')}>
        <a className="podcastItmex-miniatura" href={`https://youtu.be/${episodio.youtube}`} target="_blank" rel="noopener noreferrer" aria-label={`Ver ${episodio.clave} en YouTube`}>
            <img src={`https://i.ytimg.com/vi/${episodio.youtube}/hqdefault.jpg`} alt="" loading="lazy" />
            <span className="podcastItmex-play"><i className="fas fa-play"></i></span>
        </a>
        <div className="podcastItmex-cuerpo">
            <span className="promoItmex-aplica">Internet en Pandemia · {episodio.clave}</span>
            <h2 className="podcastItmex-titulo">{episodio.titulo}</h2>
            <p className="podcastItmex-descripcion">{episodio.descripcion}</p>
            <Plataformas episodio={episodio} />
        </div>
    </article>
);

class Podcasts extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        // Episodio que se presume arriba; el resto se lista del más reciente al primero
        const destacado = EPISODIOS.find(ep => ep.clave === EPISODIO_DESTACADO);
        const demas = EPISODIOS.filter(ep => ep !== destacado);
        return (
            <div>
                <Layout title="Red Itmex - Podcasts">
                    <section className="paginaItmex">
                        <Encabezado
                            etiqueta="Podcasts"
                            titulo="Internet en Pandemia"
                            subtitulo="Historias, retos y aprendizajes de las personas que enriquecen nuestra comunidad. ¡Escúchanos en tu plataforma favorita!"
                        >
                            <div className="podcastItmex-escuchar">
                                <a href={SPOTIFY} target="_blank" rel="noopener noreferrer"><i className="fab fa-spotify"></i> Spotify</a>
                                <a href={APPLE} target="_blank" rel="noopener noreferrer"><i className="fas fa-podcast"></i> Apple Podcasts</a>
                                <a href="https://www.youtube.com/channel/UC6Sirelw0bYpaT4VktsK19A" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i> YouTube</a>
                            </div>
                        </Encabezado>

                        <Episodio episodio={destacado} destacado />
                        <h2 className="promosItmex-grupo-titulo paginaItmex-seccion"><i className="fas fa-list"></i>Más episodios</h2>
                        <div className="podcastItmex-grid">
                            {demas.map(ep => <Episodio key={ep.clave} episodio={ep} />)}
                        </div>
                    </section>
                </Layout>
            </div >
        )
    }
};
export default Podcasts;
